<template>
  <div>
    <PageHeader title="Primes">
      <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
        <MonthSelector v-model="selectedMonth" :min-date="minDate" style="min-width: 160px" />
        <SecondaryButton class="shrink-0" @click="redirectToRetributionGrid">📊 Grille de primes</SecondaryButton>
        <SecondaryButton
          v-if="storeRetributionPaymentMethodEstalyGiftCard()"
          class="shrink-0"
          @click="openRetributionPaymentMethodModal = true"
        >
          🎁 Versement des primes
        </SecondaryButton>
      </div>
    </PageHeader>
    <Booster
      v-if="retributionsBoostEnabled() && retributionsAnalytics?.retributionConfigurationsExist"
      :retributionsAnalytics="retributionsAnalytics"
    />

    <RetributionsAnalytics
      :retributionsAnalytics="retributionsAnalytics"
      :showManagementRetributionView="showManagementRetributionView"
      :show-organization-retribution-details="false"
      @viewDetails="viewDetails"
    />
    <RetributionDetailsModal
      v-if="sellerIdDetails"
      :seller-id="sellerIdDetails"
      :start-at="startAt"
      :end-at="endAt"
      :open="openDetailsModal"
      @close="openDetailsModal = false"
    />
    <EstalyGiftCardModal :open="openRetributionPaymentMethodModal" @close="openRetributionPaymentMethodModal = false" />
  </div>
</template>

<script>
import { MonthSelector, PageHeader, SecondaryButton } from "@estaly/ui";
import { startOfMonth, endOfMonth, format } from "date-fns";
import { mapActions, mapState, mapGetters } from "vuex";
import EstalyGiftCardModal from "@/components/retribution/EstalyGiftCardModal.vue";
import RetributionsAnalytics from "@/components/retribution/RetributionsAnalytics.vue";
import Booster from "@/components/retribution/Booster.vue";
import RetributionDetailsModal from "@/components/retribution/RetributionDetailsModal.vue";
import { boosterThresholds } from "@/utils/booster";

export default {
  components: {
    RetributionDetailsModal,
    MonthSelector,
    PageHeader,
    SecondaryButton,
    RetributionsAnalytics,
    EstalyGiftCardModal,
    Booster,
  },

  data() {
    return {
      openRetributionPaymentMethodModal: false,
      retributionsAnalytics: null,
      selectedMonth: new Date(),
      minDate: new Date(2025, 8, 1),
      openDetailsModal: false,
      sellerIdDetails: null,
    };
  },

  mounted() {
    this.handleMonthChange();
  },

  computed: {
    ...mapState("store", ["selectedStoreId"]),
    ...mapGetters("store", ["storeRetributionPaymentMethodEstalyGiftCard", "retributionsBoostEnabled"]),
    ...mapGetters("auth", ["isSeller"]),

    totalSales() {
      if (!this.retributionsAnalytics?.ranking?.length) return 0;
      return this.retributionsAnalytics.ranking.reduce((acc, item) => acc + (item.totalRetributions || 0), 0);
    },

    reachedTier() {
      const tiers = [...boosterThresholds].sort((a, b) => b.threshold - a.threshold);
      return tiers.find((tier) => this.totalSales >= tier.threshold) || null;
    },

    startAt() {
      if (!this.selectedMonth) return null;

      const d = startOfMonth(this.selectedMonth);
      // On force bien 00:00:00 locale
      d.setHours(0, 0, 0, 0);

      return format(d, "yyyy-MM-dd'T'HH:mm:ss"); // ex: "2025-11-01T00:00:00"
    },

    endAt() {
      if (!this.selectedMonth) return null;

      const d = endOfMonth(this.selectedMonth);
      // On force bien 23:59:59 locale
      d.setHours(23, 59, 59, 999);

      return format(d, "yyyy-MM-dd'T'HH:mm:ss"); // ex: "2025-11-30T23:59:59"
    },

    showManagementRetributionView() {
      return !this.isSeller;
    },
  },

  watch: {
    selectedMonth() {
      this.handleMonthChange();
    },
  },

  methods: {
    ...mapActions("retributions", ["fetchRetributionsAnalytics"]),

    async handleMonthChange() {
      if (!this.selectedMonth) return;

      this.retributionsAnalytics = await this.fetchRetributionsAnalytics({
        storeId: this.selectedStoreId,
        startAt: this.startAt,
        endAt: this.endAt,
      });
    },

    redirectToRetributionGrid() {
      this.$router.push({
        path: "/pos/retribution-configurations",
        query: this.reachedTier ? { tier: this.reachedTier.tier } : {},
      });
    },

    viewDetails(sellerId) {
      this.sellerIdDetails = sellerId;
      this.openDetailsModal = true;
    },
  },
};
</script>
